import React from "react";
import VariantGate from './_variant_gate';
import NavBar from "../components/common/nav_bar";
import MaintenanceBanner from "../components/common/maintenance_banner";
import ScrollToTopButton from "../components/common/scroll_to_top_button";
import InfraStatusPanel from "../components/backtest_page/infra_status_panel";
import ErrorStatsPanel from "../components/backtest_page/error_stats_panel";
import ErrorLogPanel from "../components/backtest_page/error_log_panel";
import BacktestPageV2 from "../components/backtest_page_v2/backtest_page_v2";
import BacktestPageV3 from "../components/backtest_page_v3/backtest_page_v3";
import { requireLoginOrThrow } from "../utils/auth";
import { getNavCollapsed, setNavCollapsed } from "../utils/navState";

class BacktestPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: getNavCollapsed(),
            refreshKey: 0,
        };
    }

    componentDidMount() {
        // eslint-disable-next-line no-restricted-syntax -- componentDidMount only
        requireLoginOrThrow();
    }

    onCollapse = (collapsed) => {
        setNavCollapsed(collapsed);
        this.setState({ collapsed });
    };

    render() {
        const { collapsed, refreshKey } = this.state;

        return (
            <div className="min-h-screen w-full bg-surface text-content sm:overflow-x-auto">
                <NavBar collapsed={collapsed} onCollapse={this.onCollapse} />
                <main
                    className={`min-w-0 w-full pt-12 pb-16 sm:pt-0 sm:pb-0 transition-[padding-left] duration-200 ${
                        collapsed ? "sm:pl-[56px]" : "sm:pl-[220px]"
                    }`}
                    style={{ marginTop: "var(--maintenance-banner-h, 0px)" }}
                >
                    <MaintenanceBanner />
                    <div className="mx-3 my-3 min-w-0 rounded-2xl border border-surface-border bg-surface-card p-4 shadow-card sm:mx-6 sm:my-5 sm:p-6 lg:min-w-[960px]">
                        {/* 헤더 + 새로고침 버튼 */}
                        <div className="flex flex-wrap items-center justify-between gap-2">
                            <div>
                                <div className="text-sm text-content-secondary">백테스트 / 수집 모니터링</div>
                                <h1 className="mt-1 text-xl font-semibold text-content">수집 모니터링</h1>
                            </div>
                            <button
                                type="button"
                                onClick={() => this.setState(prev => ({ refreshKey: prev.refreshKey + 1 }))}
                                className="flex items-center gap-1 rounded-lg border border-surface-border px-2 py-1 text-xs font-medium text-content-secondary hover:bg-surface-hover transition-colors"
                                aria-label="새로고침"
                            >
                                <svg className="h-3 w-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M21 12a9 9 0 11-9-9c2.52 0 4.93 1 6.74 2.74L21 8" />
                                    <path d="M21 3v5h-5" />
                                </svg>
                                <span className="hidden sm:inline">새로고침</span>
                            </button>
                        </div>

                        {/* 2단 Bento 레이아웃: InfraStatus + ErrorStats 좌우, ErrorLog 전체 너비 */}
                        <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-2">
                            <InfraStatusPanel key={`infra-${refreshKey}`} />
                            <ErrorStatsPanel key={`stats-${refreshKey}`} />
                            <div className="lg:col-span-2">
                                <ErrorLogPanel key={`log-${refreshKey}`} />
                            </div>
                        </div>
                    </div>
                </main>
                <ScrollToTopButton />
            </div>
        );
    }
}

// DAS-70 Wave-A: variant 슬롯 3-단 확장 (v1 / v2 슬롯 / v3 정보 구조 재설계)
const BacktestPageV1 = BacktestPage;
export { BacktestPageV1 };
const BacktestPageWithVariant = (props) => (
    <VariantGate v1={BacktestPageV1} v2={BacktestPageV2} v3={BacktestPageV3} fallbackToV1={true} {...props} />
);
export default BacktestPageWithVariant;
